/**
 * The clump. Not an enemy so much as a piece of level that hurts.
 *
 * It never moves and it cannot be killed. It sits in a doorway or a corner and
 * punishes anyone who walks into it, which is entirely a lighting problem: in
 * a lit room you will never touch one.
 */

import { clamp01 } from '../../core/math';
import { holdStill, setMode, tryAttack, type Behavior } from '../brain';
import { ENTITY_TUNING } from '../defs';

const T = ENTITY_TUNING.clump;

export const clumpBehavior: Behavior = {
  kind: 'clump',

  spawn(a) {
    a.turnRate = 0;
    a.state.awareness = 0;
    a.desiredYaw = a.rng.range(0, Math.PI * 2);
    a.state.yaw = a.desiredYaw;
  },

  think(a, w) {
    const s = a.state;
    holdStill(a);

    if (s.distToPlayer > T.dreadRange) {
      setMode(a, w, 'dormant');
      s.awareness = 0;
      return;
    }

    // Close enough to smell. Awareness here is the player's problem, not its own.
    s.awareness = clamp01(1 - s.distToPlayer / T.dreadRange);
    w.dread(s, a.def.sanityDrain * s.awareness);

    if (s.distToPlayer <= a.def.attackRange) {
      setMode(a, w, 'attack');
      tryAttack(a, w);
    } else {
      setMode(a, w, 'stalk');
    }
  },
};
